/**
 * Light or dark, following the system on every device (doc 01 §2.1: "Light/dark
 * from system; the mockup ships both"). Book&Host forced light on desktop; the
 * handoff's tokens.css defines both themes under [data-theme].
 */
export function initTheme(): () => void {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {};
  const media = window.matchMedia('(prefers-color-scheme: dark)');
  const apply = (dark: boolean) =>
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
  apply(media.matches);
  const listener = (e: MediaQueryListEvent) => apply(e.matches);
  media.addEventListener('change', listener);
  return () => media.removeEventListener('change', listener);
}
